import mitt, { type Emitter } from 'mitt';
import * as EventConstants from '@/utils/event/constants';

type DeepValues<T> = T extends object
    ? { [K in keyof T]: DeepValues<T[K]> }[keyof T]
    : T extends string
        ? T
        : never;

export type AppEventKeys = DeepValues<typeof EventConstants>;
export type AppEvents = Record<AppEventKeys, any>;

export const emitter: Emitter<AppEvents> = mitt<AppEvents>();
